import { getVueReferrer } from '@marketplace/helpers/url.js'

// Every time the route changes (fired on initialization too)
export default ({ app }) => {
    app.router.beforeEach((to, from, next) => {
        // If we redirect the user after an auth check, keep the original referrer
        if (to.query?.returnUrl) {
            next()

            return
        }

        to.meta.referrer = getVueReferrer(from) // Accessible in component with this.$route.meta.referrer

        next()
    })
}
